// The "empty means absent" contract for widget copy, in one place.
//
// A cleared field must remove its key rather than store "", "   " or []. The
// widget's resolution chain treats an absent key as "not configured" but a
// present-but-empty value as "configured with nothing", which renders a blank
// screen instead of falling back. This used to be inlined in every editor, and
// the invariant then rested on each call site remembering it.
//
// Whitespace-only counts as unset; we do NOT trim otherwise, because trimming a
// controlled input on every keystroke eats the spaces between words.
//
// The empty-array branch is defence in depth, not a live path: every caller
// already sends null when its list empties (QuickReplyListEditor.removeAt,
// PatternListField's onChange). It is here so the invariant does not rest on
// each of them remembering.
export function setOrDelete(obj, key, value) {
  const next = { ...obj };
  const cleared =
    value === null ||
    value === "" ||
    (typeof value === "string" && value.trim() === "") ||
    (Array.isArray(value) && value.length === 0);
  if (cleared) delete next[key];
  else next[key] = value;
  return next;
}
